<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isCommunityDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'

export default {
  name: 'Community-edit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_COMMUNITY',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/community/communityUpdate',
      formAddUrl: '/modules/community/communityAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '区域', key: 'areaId', type: 'select', required: true, disabled: false, data: [] },
          { name: '社区名称',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 30, message: '社区名称长度不能超过30', trigger: 'blur' }
            ] }
          // { name: '社区户数',
          //   key: 'house',
          //   type: 'text',
          //   required: true,
          //   disabled: false,
          //   rules: [
          //     { validator: this.$wtValidator.ValidatorGreaterZeroInt, trigger: 'blur' },
          //     { validator: this.ValidatorGreaterZeroInt, trigger: 'blur' }
          //   ] },
        ]
      }
    }
  },
  created() {
    this.requestArea()
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddCommunityDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateCommunityDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddCommunityDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    requestUpdateCommunityDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    requestArea() {
      request({
        url: '/modules/addressArea/addressAreaList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.detailForm.elements[0].data = res.data
        }
      })
    },
    ValidatorGreaterZeroInt(rule, value, callback) {
      if (value * 1 <= 0) {
        callback(new Error('请输入不小于0的整数'))
      } else {
        callback()
      }
    }
  },
  computed: {
    ...mapState({
      isCommunityDetailLoading: state => state.community.isCommunityDetailLoading,
      detailFormData: state => state.community.communityDetailData
    })
  }
}
</script>

<style scoped>

</style>
